import { Col, message, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { createRoute } from '../utils/CustomFunc';
import { useSelector } from 'react-redux';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import liracrypt from './Liracrypt/liracrypt';
import noImg from '../assets/static/noImg.jpeg';
import { useLocation } from 'react-router-dom';
import ZenModal from './ZenModal';
import {
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    DownloadOutlined,
    AuditOutlined,
    ProfileOutlined,
    FileDoneOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    PieChartOutlined,
    BarChartOutlined,
    ApartmentOutlined,
    EllipsisOutlined,
    HolderOutlined,
    MenuOutlined,
    RightSquareOutlined,
    LeftSquareOutlined,
    MenuUnfoldOutlined,
    BarcodeOutlined
} from "@ant-design/icons";
import ImageView from './ImageView/ImageView';
import queryString from 'query-string';

const MultiTextDynamic = ({
    data = [],
    urlData,
    src = 'data',
    containerStyle = {},
    api,
    record = {},
    params
}) => {
    const icons = {
        EllipsisOutlined,
        HolderOutlined,
        MenuOutlined,
        EditOutlined,
        DeleteOutlined,
        EyeOutlined,
        LoadingOutlined,
        SolutionOutlined,
        MobileOutlined,
        ControlOutlined,
        FileJpgOutlined,
        DownloadOutlined,
        AuditOutlined,
        ProfileOutlined,
        FileDoneOutlined,
        UpSquareOutlined,
        DownSquareOutlined,
        PieChartOutlined,
        BarChartOutlined,
        ApartmentOutlined,
        RightSquareOutlined,
        LeftSquareOutlined,
        MenuUnfoldOutlined,
        BarcodeOutlined
    }
    const [pageConfig, setPageConfig] = useState();

    const [_data, setData] = useState([]);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = type, loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const getData = () => {
        if (src === 'dynamic') {
            liracrypt.get(api, { ...searchParams, ...urlData, ...params })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        setData(data.data);
                        setPageConfig(data.config);
                    } else {
                        message.error(data.message || 'Something went wrong');
                    }
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp();
                })
        }
    }


    useEffect(() => {
        if (src !== 'dynamic') {
            setData(data);
        }
    }, [data]);

    useEffect(() => {
        if (src === 'dynamic') {
            getData();
            let interval;
            if (pageConfig?.interval) {
                interval = setInterval(() => {
                    getData();
                }, pageConfig?.interval);
            }
            return (() => clearInterval(interval))
        }
    }, [pageConfig?.interval]);

    const IconComponent = (props) => {
        const Icon = props.icon;
        return Icon ? <Icon {...props} /> : <></>
    }

    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = ({ record, zenPop }) => {
        if (zenPop) {
            let zenPopDataIndex = { ...zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }

    return (
        <>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
            {
                _data.length ?
                    <Row style={containerStyle}>
                        {
                            _data.map((x, i) => (
                                <Col key={`multi-text-${i}`} span={x.colSize} style={{ display: 'inline-flex', alignItems: 'center', ...x.style }}>
                                    {
                                        x.img ? (
                                            <ImageView
                                                onClick={() => onColumnClick({ record, zenPop: x.zenPop })}
                                                isCacheble={true}
                                                source={x.img.typ || 'dynamic'}
                                                src={record[x['din']]}
                                                height="100%"
                                                width={x.style.width || '100%'}
                                                spinSize={40}
                                                urlData={{ ...searchParams, ...urlData, ...x.img.params, [x.din]: record[x.din] }}
                                            />
                                        ) :
                                            <p style={{ marginBottom: 0, width: '100%' }}>
                                                {
                                                    x.animation ?
                                                        <marquee direction={x.animation.direction} scrollamount={x.animation.speed}>
                                                            {x.din.map((din, idx) => (
                                                                <span key={idx} style={{ marginRight: 50 }}>{record[din]}</span>
                                                            ))}
                                                        </marquee> :
                                                        <span style={{ display: 'block', width: '100%', cursor: x.zenPop ? 'pointer' : 'normal' }} onClick={() => onColumnClick({ record, zenPop: x.zenPop })}>{record[x.din]}</span>
                                                }
                                            </p>
                                    }
                                    {/* {
                                        x.zenPop ?
                                            <>
                                                <IconComponent icon={icons[x.icon]} style={{ paddingLeft: 10 }} onClick={() => onColumnClick(x)} />
                                            </> : <></>
                                    } */}
                                </Col>
                            ))
                        }
                    </Row> : <></>
            }
        </>

    )
};

export default MultiTextDynamic;